
export default (() => {

    const getInitialValues = (formMode, defaultValues, objectToEdit) => {

        switch (formMode) {

            case 'add':
                return defaultValues;

            case 'edit':
                return objectToEdit;

            default:
                return defaultValues;
        }
    };

    return {
        getInitialValues
    };

})();


// WEBPACK FOOTER //
// ./services/formInitialiser.js